import React, { useState, useMemo, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../../services/tools/componentFunctions';
import * as certificateServices from '../../../../../services/certificateServices';
import css from './CertificateIssue.module.css';

import toShort from '../../../../../services/utils/dateParser';

function CertificateIssue({ detailsTo }) {
    const [filter, setFilter] = useState('');
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    useEffect(() => {
        certificateServices
            .getOption('pendingCertificates')
            .then((res) => {
                // console.log(res);
                setData(res.data);
            })
            .catch((err) => {
                console.error('Error fetching certificate issue data:', err);
            });
    }, []);

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    // ---------------------------------------
    const headers = Object.keys(data[0]);
    //-------------------------------------

    // console.log(caller);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                    //box-shadow: 0 0 8px 0 #54b5f7;
                    // style={{color: isError ? "red" : "black"}}
                />
                <div
                    className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                        componentFunctions.downloadCSV(sortedAndFilteredData, `certificate_issue_${componentFunctions.getToday()}.csv`)
                    }
                >
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
            </div>
            {/* <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Closed?
                    <input type="checkbox" onChange={handleShowClosedFilter} value={showClosed} />
                </label>
                <label>
                    Show Cancelled?
                    <input type="checkbox" onChange={handleShowCancelledFilter} value={showCancelled} />
                </label>
            </div> */}
            <h2>Certificates ready to be issued</h2>
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort(data.courseNo)} className={css.th}>
                            Course No
                            {/* {sortConfig.key === data.courseNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.studentNo)} className={css.th}>
                            Student No
                            {/* {sortConfig.key === data.studentNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.studentName)} className={css.th}>
                            Student Name
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.courseTitle)} className={css.th}>
                            Course Title
                            {/* {sortConfig.key === data.courseTitle ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.courseStart)} className={css.th}>
                            Start
                            {/* {sortConfig.key === data.courseStart ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.courseEnd)} className={css.th}>
                            End
                            {/* {sortConfig.key === data.courseEnd ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.courseLocation)} className={css.th}>
                            Location
                            {/* {sortConfig.key === data.courseLocation ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.requestId)} className={css.th}>
                            Req#
                            {/* {sortConfig.key === data.requestId ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        {/* <th></th> */}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((x, index) => (
                            <tr
                                key={x.certificateId}
                                id={x.certificateId}
                                // onClick={() => navigate(detailsTo + x.certificateId)}
                                className={css.row}
                            >
                                <td className={css.td}>{x.courseNo}</td>

                                <td className={css.td}>
                                    <Link to={`/student/details/${x.studentNo}`} className={css.link}>
                                        {x.studentNo}
                                    </Link>
                                </td>

                                <td className={css.td}>
                                    <Link to={`/student/details/${x.studentNo}`} className={css.link}>
                                        {x.studentName}
                                    </Link>
                                </td>

                                <td className={css.td}>{x.courseTitle}</td>

                                <td className={css.tdWide} style={x.courseStart === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.courseStart)}
                                </td>
                                <td className={css.tdWide} style={x.courseEnd === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.courseEnd)}
                                </td>

                                <td className={css.td}>{x.courseLocation}</td>

                                <td className={css.td}>{x.requestId}</td>

                                {/* <td className={css.td}>
                                    {x.certificateLink && (
                                        <Link to={x.certificateLink} target="_blank" rel="noopener noreferrer">
                                            <i className="fa-solid fa-award"></i>
                                        </Link>
                                    )}
                                </td> */}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default CertificateIssue;
